export enum BIEventType {

    SessionStart = "Session Start",
    SessionEnd = "Session End",
    ViewLoaded = "View loaded",
    MenuInteraction = "Menu Interaction",
    SymbolsViewInteraction = "Symbols View Interaction",
    MyTradesViewInteraction = "My trades View Interaction",
    SignalsViewInteraction = "Signals View Interaction",
    AlertsViewInteraction = "Alerts View Interaction",
    AccountViewInteraction = "Account View Interaction",
    SymbolPanelOpened = "Symbol Panel Opened",
    SymbolPanelClosed = "Symbol Panel Closed",
    SymbolPanelInteraction = "Symbol Panel Interaction",
    SymbolAlertCreated = "Symbol Alert Created",
    OrderDetailsInteraction = "Order Details Interaction",
    PositionOpened = "Position Opened",
    PositionUpdated = "Position Updated",
    PositionClosed = "Position Closed",
    OrderCreated = "Order Created",
    OrderUpdated = "Order Updated",
    OrderCancelled = "Order Cancelled",
    TradeError = "Trade Error",
    TradeErrorUI = "Trade Error UI",
    MarginCall = "Margin call",
    Liquidation = "Liquidation",
    ChartInteraction = "Chart Interaction",
    BannerInteraction = "Banner Interaction",
    WalkThroughStarted = "WalkThrough started",
    WalkThroughCompleted = "WalkThrough completed",
    WatchVideo = "Watch video",
    StopVideo = "Stop video",
    NotificationCenterInteraction = "Notification center interaction",
    DepositDecision = "Deposit Decision",
    DepositPageOpened = "Deposit Page Opened",
    DepositPageLoadError = "Deposit Page Load Error",
    NativeInteraction = "Native Interaction",
    NativeSignUp = "Native Sign Up",
    NativeLogin = "Native Login"
}
